import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCashReceiptJournalReport } from "./autogen/AutogenLayoutCashReceiptJournalReport";

export class CashReceiptJournalReport extends AutogenLayoutCashReceiptJournalReport {
    override onLoad(): void {
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }
}
